import dayjs, { Dayjs } from "dayjs";
import { useMemo } from "react";
import CalendarDay, { CalendarDayProps } from "./CalendarDay";

export interface CalenDarMonthProps {
	monthDateValue: Dayjs;
	value: Dayjs;
	formatter?: (item: CalendarDayProps) => CalendarDayProps;
	onChange: (val?: Dayjs) => void;
}
export default function CalenDarMonth(props: CalenDarMonthProps) {
	const days = useMemo(() => {
		// 每个月份格子 5 * 7
		const grids = getInitialGrids();
		const year = props.monthDateValue.year();
		const monthIndex = props.monthDateValue.month();

		// 月的第一天是周几
		const week = dayjs(new Date(year, monthIndex, 1)).day();

		// 月最后一天 eg：31
		const endDate = props.monthDateValue.daysInMonth();

		for (let index = 0; index < grids.length; index++) {
			let item = grids[index];
			const dateText = index + 1 - week;
			if (index >= week && dateText <= endDate) {
				const date = dayjs(new Date(year, monthIndex, dateText));
				item.date = date;
				item.text = dateText;
				item.disabled = false;
				item.selected = props.value.isSame(date, "d");
				if (props.formatter) {
					item = { ...props.formatter(item) };
				}
				grids[index] = { ...item };
			}
		}
		return grids;
	}, [props]);

	const onSelected = (val?: Dayjs) => {
		if (!val) return;
		const _date = dayjs(new Date(val.year(), val.month(), val.date(), props.value.hour(), props.value.minute()));
		props.onChange(_date);
	};

	return (
		<div className="mt-3 grid grid-flow-row grid-cols-7 gap-2 text-center xs:gap-4">
			{days.map((item, key) => (
				<CalendarDay key={item.date ? item.text : key + 100} {...item} onSelected={onSelected} />
			))}
		</div>
	);
}

function getInitialGrids() {
	return new Array(35).fill(undefined).map((item) => {
		return {
			text: undefined,
			date: undefined,
			disabled: true,
			selected: false,
		} as CalendarDayProps;
	});
}
